module.exports = __webpack_public_path__ + "static/media/forgotPass2.63bac577.svg";